import { PRODUCTS_PERIOD_FILTER_EVENTS } from './global-events';

export const productsPeriodCalendarEventMap = {
  'range-selected': PRODUCTS_PERIOD_FILTER_EVENTS.PRODUCTS_PERIOD_FILTER_DATES_RANGE,
};

export const productsPeriodFilterOptions = [
  {
    id: 'current_month',
    name: 'Поточний місяць',
    event: PRODUCTS_PERIOD_FILTER_EVENTS.PRODUCTS_PERIOD_FILTER_CURRENT_MONTH,
    options: {
      type: 'checkbox',
      activeFilter: false,
    },
  },
  {
    id: 'months',
    name: 'Місяць',
    event: PRODUCTS_PERIOD_FILTER_EVENTS.PRODUCTS_PERIOD_FILTER_MONTH,
    options: {
      type: 'checkbox',
    },
  },
  {
    id: 'weeks',
    name: 'Тиждень',
    event: PRODUCTS_PERIOD_FILTER_EVENTS.PRODUCTS_PERIOD_FILTER_WEEK,
    options: {
      type: 'checkbox',
    },
  },
  {
    id: 'days',
    name: 'День',
    event: PRODUCTS_PERIOD_FILTER_EVENTS.PRODUCTS_PERIOD_FILTER_DAY,
    options: {
      type: 'checkbox',
    },
  },
];
